export const myId = () => localStorage.getItem("id");

export const isRcon = () => localStorage.getItem("role") === "rcon";

export const canManage = () => true;

export const canSeeLogs = () => localStorage.getItem("logs") === "1";
